<mat-toolbar class="obg-m-complete-account-login-toolbar" *ngIf="isMobileDevice">
	<h1 class="obg-m-complete-account-login-toolbar-title">
		{{ 'migrated-user.complete-account.toolbar-title' | translate }}
	</h1>
</mat-toolbar>

<div class="obg-m-complete-account-login-container">
	<img class="obg-m-complete-account-login-image" alt="img" obgImageContent="general.login-alert" />

	<h1 class="obg-m-complete-account-login-title">{{ 'migrated-user.complete-account.title' | translate }}</h1>

	<p class="obg-m-complete-account-login-description">
		{{ 'migrated-user.complete-account.description' | translate }}
	</p>

	<form
		*ngIf="formGroup"
		class="obg-m-complete-account-login-form"
		test-id="migrated-user.obg-m-complete-account-login-form"
		data-test-id="migrated-user.obg-m-complete-account-login-form"
		novalidate
		[formGroup]="formGroup"
	>
		<div *ngIf="formGroup.controls.personalCode" class="obg-m-complete-account-login-personal-code">
			<obg-m-select
				*ngIf="formGroup.controls.personalCodeType"
				test-id="personal-code-type"
				[control]="formGroup.controls.personalCodeType"
				[options]="documentTypes"
				[placeholder]="'migrated-user.personal-code.type' | translate"
			>
			</obg-m-select>

			<div class="personal-code">
				<mat-form-field>
					<input
						matInput
						[formControl]="formGroup.controls.personalCode"
						name="personalCode"
						type="text"
						test-id="personal-code"
						[placeholder]="selectedDocument?.placeholderKey | translate"
						required
					/>
				</mat-form-field>

				<obg-common-validation-renderer
					[input]="formGroup.controls.personalCode"
					[translationPrefix]="selectedDocument.documentNumberValidatorPrefix"
				>
				</obg-common-validation-renderer>
			</div>
		</div>
		<obg-m-select
			*ngIf="formGroup.controls.birthCountry"
			class="select-field"
			test-id="migrated-user.obg-m-complete-account-login-form-birth-country"
			data-test-id="migrated-user.obg-m-complete-account-login-form-birth-country"
			[control]="formGroup.controls.birthCountry"
			[options]="countries$ | async"
			[placeholder]="'migrated-user.complete-account.birth-country' | translate"
		>
		</obg-m-select>

		<obg-m-select
			*ngIf="formGroup.controls.nationality"
			class="select-field"
			test-id="migrated-user.obg-m-complete-account-login-form-nationality"
			data-test-id="migrated-user.obg-m-complete-account-login-form-nationality"
			[control]="formGroup.controls.nationality"
			[options]="nationalities$ | async"
			[placeholder]="'migrated-user.complete-account.nationality' | translate"
		>
		</obg-m-select>
	</form>

	<p class="obg-m-complete-account-login-error" *ngIf="componentState === 'error'">{{ errorCode | translate }}</p>

	<button
		class="obg-m-complete-account-login-button"
		test-id="migrated-user.obg-m-complete-account-login-button"
		data-test-id="migrated-user.obg-m-complete-account-login-button"
		type="submit"
		color="accent"
		mat-flat-button
		[disabled]="componentState === 'loading'"
		(click)="onSubmit()"
	>
		{{ "general.continue" | translate }}
	</button>
</div>
